import { useSeatManagementPortal } from "api/customerPortal";
import { useQuery } from "react-query";
import { CHECKOUT_URL } from "constants/pages";

export const useAddPaymentCallback = () => {
  const { mutate: fireSeatManagementPortal } = useSeatManagementPortal();
  const queryParams = new URLSearchParams(window.location.search);
  const paymentMethodCallback = queryParams.get("payment_method_callback");
  useQuery({
    queryKey: ["seatManagementPortal", paymentMethodCallback],
    queryFn: async () => {
      if (paymentMethodCallback === "true") {
        const data = await fireSeatManagementPortal({
          data: {
            cancel_url: CHECKOUT_URL.CANCEL,
            success_url: CHECKOUT_URL.SUCCESS,
            payment_method_callback: true,
          },
        });
        if (data?.url) {
          window.location.href = data?.url;
        }
      }
    },
    enabled: paymentMethodCallback === "true",
  });

  return {
    isPaymentCallbackActive: paymentMethodCallback === "true",
  };
};
